/*
 * Accessibility fixes (draft) - 2026-09-25
 * Loaded (defer) after theme.min.js / custom.js. Patches Slick + Plyr before
 * the theme's jQuery-ready init runs, then adds keyboard/ARIA behaviour.
 */
(function (window, document) {
  'use strict';
  var $ = window.jQuery;
  if (!$) { return; }

  var KEY_TAB = 9, KEY_ENTER = 13, KEY_ESC = 27, KEY_SPACE = 32;
  var FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';

  function isVisible(el) {
    if (!el || !el.getClientRects().length) { return false; }
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  }
  function focusables(ctx) {
    return $(ctx).find(FOCUSABLE).filter(function () {
      return isVisible(this) && !$(this).closest('[aria-hidden="true"]').length;
    });
  }

  /* ------------------------------------------------------------------ */
  /* Slick carousels: valid ARIA, labelled dots, real <button> arrows     */
  /* ------------------------------------------------------------------ */
  function arrowToButton(markup, label) {
    if (typeof markup !== 'string' || !/^\s*<div/i.test(markup)) { return markup; }
    return markup
      .replace(/^\s*<div/i, '<button type="button" aria-label="' + label + '"')
      .replace(/<\/div>\s*$/i, '</button>')
      .replace(/<i /g, '<i aria-hidden="true" ');
  }

  function fixSlick(s) {
    if (!s || !s.$slider) { return; }
    try {
      if (s.$slideTrack) {
        s.$slideTrack.removeAttr('role');
        s.$slideTrack.children('.slick-slide').each(function () {
          var $sl = $(this);
          $sl.removeAttr('role aria-describedby aria-selected');
          if ($sl.hasClass('slick-active')) {
            $sl.removeAttr('aria-hidden');
            $sl.find('a, input, button, select, textarea').attr('tabindex', '0');
          } else {
            $sl.attr('aria-hidden', 'true');
            $sl.find('a, input, button, select, textarea').attr('tabindex', '-1');
          }
        });
      }
      if (s.$list) { s.$list.removeAttr('role aria-live'); }
      if (s.$dots && s.$dots.length) {
        s.$dots.removeAttr('role');
        s.$dots.closest('div').filter('[role="toolbar"]').removeAttr('role');
        var $lis = s.$dots.children('li');
        var total = $lis.length;
        var isThumbs = $lis.find('img').length > 0;
        $lis.each(function (i) {
          var $li = $(this);
          $li.removeAttr('role aria-hidden aria-selected aria-controls id');
          var $b = $li.children('button').first();
          if (!$b.length) { return; }
          $b.attr('type', 'button').removeAttr('role data-role tabindex');
          $b.attr('aria-label', isThumbs ? ('Show image ' + (i + 1) + ' of ' + total) : ('Go to slide ' + (i + 1)));
          $b.find('img').attr('alt', '');
          if ($li.hasClass('slick-active')) { $b.attr('aria-current', 'true'); } else { $b.removeAttr('aria-current'); }
        });
      }
      if (s.$prevArrow && s.$prevArrow.length) { s.$prevArrow.removeAttr('role aria-controls aria-hidden'); }
      if (s.$nextArrow && s.$nextArrow.length) { s.$nextArrow.removeAttr('role aria-controls aria-hidden'); }
    } catch (e) { /* never break the carousel */ }
  }

  function patchSlick() {
    if (!$.fn.slick) { return; }
    var $tmp = $('<div style="position:absolute;left:-9999px;width:10px;height:10px;overflow:hidden" aria-hidden="true"><div></div><div></div></div>').appendTo(document.body);
    var proto = null;
    try {
      $tmp.slick({ accessibility: false, autoplay: false, arrows: false, dots: false });
      proto = $tmp[0].slick && Object.getPrototypeOf($tmp[0].slick);
      $tmp.slick('unslick');
    } catch (e) { proto = null; }
    $tmp.remove();
    if (!proto || proto.__a11yPatched) { return; }
    proto.__a11yPatched = true;

    var origBuildArrows = proto.buildArrows;
    proto.buildArrows = function () {
      this.options.prevArrow = arrowToButton(this.options.prevArrow, 'Previous slide');
      this.options.nextArrow = arrowToButton(this.options.nextArrow, 'Next slide');
      return origBuildArrows.apply(this, arguments);
    };
    proto.initADA = function () { fixSlick(this); };
    proto.activateADA = function () { fixSlick(this); };
    ['updateDots', 'setSlideClasses', 'updateArrows'].forEach(function (name) {
      var orig = proto[name];
      if (typeof orig !== 'function') { return; }
      proto[name] = function () {
        var r = orig.apply(this, arguments);
        fixSlick(this);
        return r;
      };
    });
  }

  /* ------------------------------------------------------------------ */
  /* Plyr (homepage videos): captions on, iframe title = video name       */
  /* ------------------------------------------------------------------ */
  function patchPlyr() {
    var P = window.Plyr;
    if (typeof P !== 'function' || P.__a11yPatched) { return; }
    var Wrapped = function (target, opts) {
      opts = $.extend(true, {}, opts || {});
      if ($.isArray(opts.controls) && opts.controls.indexOf('captions') === -1) {
        var i = opts.controls.indexOf('fullscreen');
        opts.controls.splice(i === -1 ? opts.controls.length : i, 0, 'captions');
      }
      opts.captions = $.extend({ active: true, update: true }, opts.captions || {});
      opts.i18n = $.extend({ frameTitle: '{title}' }, opts.i18n || {});
      var inst = new P(target, opts);
      /* Plyr reads captions.active when it builds the YouTube player (cc_load_policy);
         set it now so YouTube loads captions by default when the video has them. */
      try {
        [].concat(inst).forEach(function (pl) {
          if (pl && pl.captions && typeof pl.captions === 'object') { pl.captions.active = true; }
        });
      } catch (e) {}
      return inst;
    };
    Object.getOwnPropertyNames(P).forEach(function (k) {
      if (['prototype', 'length', 'name', 'caller', 'arguments'].indexOf(k) !== -1) { return; }
      try { Wrapped[k] = P[k]; } catch (e) {}
    });
    Wrapped.prototype = P.prototype;
    Wrapped.__a11yPatched = true;
    window.Plyr = Wrapped;
  }

  try { patchSlick(); } catch (e) {}
  try { patchPlyr(); } catch (e) {}

  /* ------------------------------------------------------------------ */
  /* Everything below runs after the theme's own ready handler.           */
  /* ------------------------------------------------------------------ */
  $(function () {
    var theme = window.theme || {};

    /* Skip link */
    $(document).on('click', '.skip-link', function (e) {
      var target = document.getElementById('MainContent');
      if (!target) { return; }
      e.preventDefault();
      target.focus();
      if (target.scrollIntoView) { target.scrollIntoView(); }
    });

    /* Space activates anchors that act as buttons */
    $(document).on('keydown', 'a[role="button"]', function (e) {
      if (e.which === KEY_SPACE) { e.preventDefault(); $(this).trigger('click'); }
    });

    /* Currency selector disclosure (header) */
    $('.js-header-sub-link').each(function () {
      var $li = $(this);
      var $btn = $li.children('button.js-header-sub-link-a');
      if (!$btn.length) { return; }
      $li.off('focusin focusout mouseout');
      function open() { $li.addClass('js-active'); $btn.attr('aria-expanded', 'true'); }
      function close(returnFocus) {
        $li.removeClass('js-active'); $btn.attr('aria-expanded', 'false');
        if (returnFocus) { $btn.trigger('focus'); }
      }
      $btn.on('click', function (e) {
        e.preventDefault();
        if ($li.hasClass('js-active')) { close(false); } else { open(); }
      });
      $li.on('keydown', function (e) {
        if (e.which === KEY_ESC && $li.hasClass('js-active')) { e.preventDefault(); e.stopPropagation(); close(true); }
      });
      $li.on('focusout', function () {
        window.setTimeout(function () {
          if (!$.contains($li[0], document.activeElement)) { close(false); }
        }, 0);
      });
      $li.on('mouseleave', function () {
        if (!$.contains($li[0], document.activeElement)) { close(false); }
      });
      $(document).on('click', function (e) {
        if ($li.hasClass('js-active') && !$.contains($li[0], e.target)) { close(false); }
      });
    });

    /* Drawers (cart / search / mobile menu) opened via Magnific Popup */
    var drawers = {
      'cart': { sel: '.js-cart-draw', label: 'Cart', trig: '.js-cart-trigger' },
      'search': { sel: '.js-search-draw', label: 'Search', trig: '.js-search-trigger' },
      'menu-draw': { sel: '.js-menu-draw', label: 'Menu', trig: '.js-mobile-draw-trigger' }
    };
    var openDrawer = null;
    if (typeof theme.mfpOpen === 'function') {
      var origMfpOpen = theme.mfpOpen;
      theme.mfpOpen = function (type) {
        var r = origMfpOpen.apply(this, arguments);
        var d = drawers[type];
        if (d) {
          var $c = $(d.sel);
          $c.attr({ 'role': 'dialog', 'aria-modal': 'true', 'aria-label': d.label });
          $(d.trig).attr('aria-expanded', 'true');
          openDrawer = d;
          $('.mfp-close').attr('aria-label', 'Close').removeAttr('title');
          window.setTimeout(function () {
            if ($c.length && !$.contains($c[0], document.activeElement)) {
              var $f = focusables($c).not('.mfp-close').first();
              if (!$f.length) { $f = focusables($c).first(); }
              if ($f.length) { $f.trigger('focus'); }
            }
          }, 120);
        }
        return r;
      };
    }
    $(document).on('mfpClose', function () {
      if (openDrawer) { $(openDrawer.trig).attr('aria-expanded', 'false'); openDrawer = null; }
    });
    $(document).on('mfpOpen mfpChange', function () {
      $('.mfp-close').attr('aria-label', 'Close').removeAttr('title');
    });

    /* Promo Pop dialog: focus in, trap, Escape, return focus */
    var $promo = $('.js-promo-pop');
    if ($promo.length && typeof theme.promoPop === 'function') {
      var lastFocus = null;
      var origPromoPop = theme.promoPop;
      theme.promoPop = function (state) {
        if (state === 'open') {
          lastFocus = document.activeElement;
          var r = origPromoPop.apply(this, arguments);
          window.setTimeout(function () {
            if (!$promo.hasClass('js-active')) { return; }
            var $input = $promo.find('.promo-pop__input');
            var $target = $input.length && isVisible($input[0]) ? $input : focusables($promo).first();
            if ($target.length) { $target.trigger('focus'); } else { $promo.trigger('focus'); }
          }, 350);
          return r;
        }
        var r2 = origPromoPop.apply(this, arguments);
        if ($.contains($promo[0], document.activeElement) || document.activeElement === $promo[0] || document.activeElement === document.body) {
          if (lastFocus && lastFocus !== document.body && document.body.contains(lastFocus) && isVisible(lastFocus)) {
            lastFocus.focus();
          } else {
            var main = document.getElementById('MainContent');
            if (main) { main.focus({ preventScroll: true }); }
          }
        }
        lastFocus = null;
        return r2;
      };
      $(document).on('keydown', function (e) {
        if (e.which !== KEY_ESC || !$promo.hasClass('js-active')) { return; }
        if ($.magnificPopup && $.magnificPopup.instance && $.magnificPopup.instance.isOpen) { return; }
        e.preventDefault();
        $promo.find('.js-promo-pop-close').first().trigger('click');
      });
      $promo.on('keydown', function (e) {
        if (!$promo.hasClass('js-active')) { return; }
        if (e.which === KEY_TAB) {
          var $f = focusables($promo);
          if (!$f.length) { e.preventDefault(); return; }
          var first = $f[0], last = $f[$f.length - 1];
          if (e.shiftKey && (document.activeElement === first || document.activeElement === $promo[0])) {
            e.preventDefault(); last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault(); first.focus();
          }
        }
      });
    }

    /* Product accordion: expose expanded state */
    function syncAccordion($t) {
      var id = ($t.attr('href') || '').replace(/^#/, '');
      var target = id ? document.getElementById(id) : null;
      if (target) {
        if (!$t.attr('aria-controls')) { $t.attr('aria-controls', id); }
        $t.attr('aria-expanded', $(target).hasClass('js-active') || $t.hasClass('js-active') ? 'true' : 'false');
      }
    }
    $('.js-accordion-trigger').each(function () { $(this).attr('role', 'button'); syncAccordion($(this)); });
    $(document).on('click', '.js-accordion-trigger', function () {
      var $t = $(this);
      window.setTimeout(function () { syncAccordion($t); }, 50);
    });

    /* Closeby store-locator launcher (app-injected iframe): give it a title */
    function titleCloseby() {
      $('iframe.closeby-launcher-embed-toggle, iframe[src*="closeby"]').each(function () {
        if (!this.getAttribute('title')) { this.setAttribute('title', 'Our Locations store locator'); }
      });
    }
    titleCloseby();
    if (window.MutationObserver) {
      var obsCount = 0;
      var obs = new MutationObserver(function () {
        titleCloseby();
        if (++obsCount > 500) { obs.disconnect(); }
      });
      obs.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () { obs.disconnect(); }, 30000);
    }
  });
})(window, document);
